<template>
  <v-tooltip
    top
    dark
  >
    <template v-slot:activator="{ on }">
      <v-chip
        class="detail-chip"
        color="primary"
        text-color="white"
        selected
        @click="onClick"
        v-on="on"
      >
        <v-avatar>
          <v-icon>create</v-icon>
        </v-avatar>
        <span>
          <b>Detail</b>

        </span>
      </v-chip>
    </template>
    Open detail page
  </v-tooltip>
</template>

<script>
export default {
  name: 'DetailChip',
  props: {
    instrument: {
      type: String,
      default: null,
      required: true,
    },
    sk: {
      type: String,
      default: null,
      required: true,
    },
  },
  methods: {
    async onClick() {
      const splittedSk = this.sk.split('#');
      if (splittedSk.length === 3) {
        this.$router.push(`/financial-products/product/${this.instrument}/${splittedSk[1]}/${splittedSk[2]}`);
      } else {
        await this.$router.push(`/financial-products/tranche/${this.instrument}/${splittedSk[1]}/${splittedSk[2]}/${splittedSk[3]}`);
        this.$emit('refreshDetailComponent');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-chip {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/financialProducts/shared/DetailChip.vue